import { action } from 'easy-peasy';
import { IActionSetExcludedClientOption } from '../types';

const setExcludedClientOption: IActionSetExcludedClientOption = action((state, payload) => {
  state.clientOptionsByTeam.excluded = payload;
});

export default setExcludedClientOption;
